module.exports = __webpack_public_path__ + "static/media/text.797cc13d.svg";